import { render } from "./IletsCoursesPage.vue?vue&type=template&id=2b66a1eb&scoped=true"
import script from "./IletsCoursesPage.vue?vue&type=script&lang=js"
export * from "./IletsCoursesPage.vue?vue&type=script&lang=js"

import "./IletsCoursesPage.vue?vue&type=style&index=0&id=2b66a1eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b66a1eb"]])

export default __exports__